import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { setPageTitle } from '../../store/themeConfigSlice';

export const Error500 = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate()
    useEffect(() => {
        dispatch(setPageTitle(t("ERROR_500")));
    }, []);

    return (
        <div className="relative flex min-h-screen items-center justify-center overflow-hidden">
            <div className="ppx-6 py-16 text-center font-semibold before:container before:absolute before:left-1/2 before:-translate-x-1/2 before:rounded-full before:bg-[linear-gradient(180deg,#4361EE_0%,rgba(67,97,238,0)_50.73%)] before:aspect-square before:opacity-10 md:py-20">
                <div className="relative">
                    <img
                        src='/assets/images/error/500-light.svg'
                        alt="500"
                        className="mx-auto -mt-10 w-full max-w-xs object-cover md:-mt-14 md:max-w-xl"
                    />
                    <p className="mt-5 text-base">{t("INTERNAL_SERVER_ERROR")}</p>
                    <div className='flex mx-auto !mt-7 w-max gap-5'>
                        <Link to="/" className="btn btn-gradient border-0 uppercase shadow-none">
                            {t("DASHBOARD")}
                        </Link>
                        <button onClick={() => location.reload()} className="btn btn-gradient border-0 uppercase shadow-none">
                            {t("REFRESH")}
                        </button>
                        <button onClick={() => navigate(-1)} className="btn btn-gradient border-0 uppercase shadow-none">
                            {t("GO_BACK")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
